module.exports = __webpack_public_path__ + "static/velourfrillhamper-1b4e4f792236cf0e1fdced8f0cc20b5c.jpeg";